import fs from 'node:fs'
import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartPresetDefinition } from '@cli-types/preset-engine/presets.js'
import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'
import { getSchemasDir } from './get-schemas-dir.js'

export function ensurePresetSchemaTargetsAvailable(
  cwd: string,
  config: ResolvedBetterstartConfig,
  definition: BetterstartPresetDefinition
): void {
  const schemasDir = getSchemasDir(cwd, config)

  for (const schemaFile of definition.schemaFiles) {
    const schemaName = schemaFile.replace(/\.json$/, '')
    const destinationPath = path.join(schemasDir, schemaFile)
    if (!fs.existsSync(destinationPath)) {
      continue
    }

    const owner = getSchemaOwner(cwd, schemaName)
    if (owner && owner !== `preset:${definition.id}`) {
      throw new Error(
        `Schema "${schemaName}" is already owned by "${owner}". Remove or rename it before installing ${definition.id}.`
      )
    }

    if (!owner) {
      throw new Error(
        `Schema "${schemaName}" already exists and is not preset-owned. Remove or rename it before installing ${definition.id}.`
      )
    }
  }
}
